import React from "react"
import {MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow} from "mdbreact"
import {useEffect} from "react"
import {Field, Form, FormElement} from "@progress/kendo-react-form"
import {useAppDispatch, useAppSelector} from "../../store"
import DealerDropdown from "../../components/Shared/dealerDropdown"
import {fetchMotOpportunityDetail} from "./activitySlice"
import {RootState} from "../../rootReducer"
import OpportunitiesGrid from "../../components/Activity/OpportunitiesGrid"
import {fetchBookingReminder} from "../MotBooking/bookingSlice"
import BookingReminderGrid from "../../components/Activity/BookingReminderGrid"

const Opportunities = () => {
    const dispatch = useAppDispatch()
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    useEffect(() => {
        if (selectedDealer) {
            dispatch(fetchMotOpportunityDetail(selectedDealer?.dealerId))
            dispatch(fetchBookingReminder(selectedDealer?.dealerId))
        }
    }, [dispatch, selectedDealer])

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Manage MOT </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Activities</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <Form
                render={() => (
                    <div
                        className="mb-2"
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "end",
                        }}
                    >
                        <FormElement style={{width: 300}}>
                            <fieldset className={"k-form-fieldset"}>
                                <Field
                                    onChange={(e: any) => {
                                        dispatch(fetchMotOpportunityDetail(parseInt(e.value)))
                                        dispatch(fetchBookingReminder(parseInt(e.value)))
                                    }}
                                    name={"feesDealerDropdown"}
                                    component={DealerDropdown}
                                />
                            </fieldset>
                        </FormElement>
                    </div>
                )}
            />
            <MDBRow>
                <MDBCol md="6">
                    <MDBCard>
                        <MDBCardBody className="p-2">
                            <MDBCardTitle className="text-muted">Booking Reminder</MDBCardTitle>
                            <BookingReminderGrid />
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
                <MDBCol className="ps-0" md="6">
                    <MDBCard>
                        <MDBCardBody className="p-2">
                            <MDBCardTitle className="text-muted">Opportunities</MDBCardTitle>
                            <OpportunitiesGrid />
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </>
    )
}
export default Opportunities
